import React from "react";
import { 
    IonRow,
    IonGrid,
  } from '@ionic/react';
import {
    useJsApiLoader,
    GoogleMap,
    DirectionsRenderer
  } from '@react-google-maps/api'

const mapContainerStyle = {
    width: '100%',
    height: '350px',
};
const center = {
    lat: 1.3521,
    lng: 103.8198
};

const MapComponent = () => {
    const google = window.google;

    const { isLoaded, loadError } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_GOOGLEMAP_API_KEY,
    })

    if (!isLoaded) {
      return (
        <div className='summary'>
            <IonGrid>
              <IonRow>
              <p>Google Loading Error!!!</p>
              </IonRow>
            </IonGrid>
            
          </div>
      )
    }


    return (
        <>
            <div className='summary'>
            <IonGrid>
              <IonRow>
                <GoogleMap
                    center={center}
                    zoom={10}
                    mapContainerStyle={mapContainerStyle}
                    options={{
                      zoomControl: false,
                      streetViewControl: false,
                      mapTypeControl: false,
                      fullscreenControl: false,
                    }}
                > 
                </GoogleMap>
  
            
              </IonRow>
            </IonGrid>
            
          </div>
        </>
    )
}

export default MapComponent ;